export const SEAT_INIT = 'SEAT_INIT'

export const SELECT_SEAT = 'SELECT_SEAT'

export const CLEAR_SEAT = 'CLEAR_SEAT'

export const UPDATE_SELECTED_SEATS = 'UPDATE_SELECTED_SEATS'



// WEBPACK FOOTER //
// ./src/store/seat/mutation-types.js